// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 30px;
  padding-bottom: 160px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background: url('recomendation_modal.png');
}
.wrapper .header-wrapper {
  text-align: center;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.wrapper .header-wrapper h3 {
  padding: 0;
  margin-bottom: 15px;
}
.wrapper .header-wrapper p {
  padding: 0 19%;
}
.wrapper .title {
  font-family: AppFontBold, sans-serif;
  width: 100%;
  color: white;
  font-size: 22px;
  text-transform: uppercase;
  padding: 20px 0px 10px;
  text-align: center;
}
.wrapper .description {
  font-family: AppFont;
  color: white;
  font-size: 14px;
  padding: 5px 0px 10px;
  text-align: center;
}
.wrapper .card-item {
  padding: 15px 0 7px;
  position: relative;
  margin: 4px 0;
  word-break: break-word;
  background: white;
  border: 2px solid white;
  width: 49%;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 2.1px 7.87px 0px rgba(79, 97, 79, 0.1490196078);
  transition: border 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.wrapper .card-item.selected {
  border: 2px solid var(--ion-color-primary);
  background: #F6FAF6;
}
.wrapper .card-item .default-img {
  padding: 5px;
  object-fit: contain !important;
  background-color: #fff;
}
.wrapper .card-item .image-block {
  width: auto;
  max-width: 70%;
  position: relative;
  margin-bottom: 8px;
}
.wrapper .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.wrapper .card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.wrapper .card-item .info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.wrapper .card-item .info-block .name {
  font-size: 13px;
  font-family: AppFont, Helvetica, sans-serif;
  margin: 10px 0 5px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: #1A1A18;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 992px) {
  .wrapper .card-item .info-block .name {
    font-size: 13px;
    height: 32px;
    overflow: hidden;
  }
}
.wrapper .card-item .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  color: #000000;
  margin: 0;
  margin-top: 20px;
  text-align: center;
}

.price {
  font-weight: 600;
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: #1A1A18;
  width: 90%;
}

.content_block {
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  background: white;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;
}
.footer-btn ion-button {
  margin: 5px 0px;
  width: 90%;
  text-transform: uppercase;
  color: #fff;
  font-size: 15px;
  min-height: 40px;
}
.footer-btn ion-button p {
  font-size: 26px;
  color: white;
  margin: 0 12px;
}
.footer-btn .cancel-btn {
  --border-color: #1A1A18;
  --border-width: 1px;
  color: #1A1A18;
  --background: transparent;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: left;
  padding-top: 6px;
}

.add-button {
  width: 100%;
  padding: 0 10px;
  border-radius: 8px;
  cursor: pointer;
  min-height: 28px;
  max-height: 28px;
  min-width: 130px;
  font-size: 12px;
}

.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  font-size: 16px;
  color: #1A1A18;
}
.quantity-selector .quantity-btn {
  width: 22px;
  height: 22px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.selected_item_icon {
  position: absolute;
  top: 5px;
  left: 5px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.selected_item_icon.active {
  z-index: 99;
  opacity: 1;
}

.footer-section {
  padding: 5px 0px 10px;
}

.separator {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 30px;
}
.separator .line {
  height: 8px;
  background-image: url('dot-white.svg');
  background-size: 7px 100%;
}
.separator--wide .line {
  background-size: 8px 100%;
}

.info {
  position: absolute;
  right: 5px;
  top: 5px;
  color: #999999;
  width: 20px;
  height: 20px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,0CAAA;AADF;AAGE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AADJ;AAEI;EACE,UAAA;EACA,mBAAA;AAAN;AAEI;EACE,cAAA;AAAN;AAIE;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,yBAAA;EAEA,sBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,oBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AALJ;AAQE;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,UAAA;EAEA,0CAAA;EACA,+DAAA;EAEA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AARJ;AAUI;EACE,0CAAA;EACA,mBAAA;AARN;AAWI;EACE,YAAA;EACA,8BAAA;EACA,sBAAA;AATN;AAYI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAVN;AAWM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AATR;AAYM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAVR;AAcI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAZN;AAcM;EACE,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAbR;ACpGE;EDmGI;IAiBI,eAAA;IACA,YAAA;IACA,gBAAA;EAZR;AACF;AAeM;EACE,cAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAbR;;AAoBA;EACE,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAjBF;AAmBE;EACE,eAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAjBJ;AAkBI;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAhBN;AAmBE;EACE,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAjBJ;;AAqBA;EACE,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAOA,YAAA;AAxBF;AAmBE;EACE,eAAA;EACA,eAAA;AAjBJ;AAsBE;EACE,eAAA;EACA,cAAA;AApBJ;AAuBE;EACE,WAAA;EACA,YAAA;AArBJ;AAuBI;EACE,YAAA;AArBN;;AA0BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;AAvBF;AAyBE;EACE,WAAA;EACA,UAAA;AAvBJ;;AA2BA;EACE,qBAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;AAxBF;AA0BE;EACE,WAAA;EACA,sCAAA;EACA,yBAAA;AAxBJ;AA0BE;EACE,yBAAA;AAxBJ;;AA4BA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAzBF","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n  padding: 30px;\n  padding-bottom: 160px;\n  overflow-x: hidden;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  background: url(\"../../../assets/background/recomendation_modal.png\");\n\n  .header-wrapper {\n    text-align: center;\n    padding: 15px 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    h3 {\n      padding: 0;\n      margin-bottom: 15px;\n    }\n    p {\n      padding: 0 19%;\n    }\n  }\n\n  .title {\n    font-family: AppFontBold, sans-serif;\n    width: 100%;\n    color: white;\n    font-size: 22px;\n\n    text-transform: uppercase;\n\n    padding: 20px 0px 10px;\n    text-align: center;\n  }\n\n  .description {\n    font-family: AppFont;\n    color: white;\n    font-size: 14px;\n    padding: 5px 0px 10px;\n    text-align: center;\n  }\n\n  .card-item {\n    padding: 15px 0 7px;\n    position: relative;\n    margin: 4px 0;\n    word-break: break-word;\n    background: white;\n    border: 2px solid white;\n    width: 49%;\n\n    border-radius: var(--custom-border-radius);\n    box-shadow: 0px 2.1px 7.87px 0px #4F614F26;\n\n    transition: border 200ms linear;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n\n    &.selected {\n      border: 2px solid var(--ion-color-primary);\n      background: #F6FAF6;\n    }\n\n    .default-img {\n      padding: 5px;\n      object-fit: contain !important;\n      background-color: #fff;\n    }\n\n    .image-block {\n      width: auto;\n      max-width: 70%;\n      position: relative;\n      margin-bottom: 8px;\n      ion-img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n\n      .plus {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        height: 32px;\n        width: 32px;\n      }\n    }\n\n    .info-block {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-between;\n\n      .name {\n        font-size: 13px;\n        font-family: AppFont, Helvetica, sans-serif;\n        margin: 10px 0 5px;\n        display: flex;\n        align-items: center;\n        text-transform: uppercase;\n        color: #1A1A18;\n        word-break: break-word;\n\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n\n        @include mobile {\n          font-size: 13px;\n          height: 32px;\n          overflow: hidden;\n        }\n      }\n\n      .deposit_text {\n        font-size: 9px;\n        font-family: AppFont, sans-serif;\n        color: #000000;\n        margin: 0;\n        margin-top: 20px;\n        text-align: center;\n      }\n\n    }\n  }\n}\n\n.price {\n  font-weight: 600;\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  color: #1A1A18;\n  width: 90%;\n}\n\n.content_block {\n  overflow-y: auto;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.footer-btn {\n  position: fixed;\n  bottom: 20px;\n  left: 0px;\n  right: 0px;\n  background: white;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 15px 0;\n\n  ion-button {\n    margin: 5px 0px;\n    width: 90%;\n    text-transform: uppercase;\n    color: #fff;\n    font-size: 15px;\n    min-height: 40px;\n    p {\n      font-size: 26px;\n      color: white;\n      margin: 0 12px;\n    }\n  }\n  .cancel-btn {\n    --border-color: #1A1A18;\n    --border-width: 1px;\n    color: #1A1A18;\n    --background: transparent;\n  }\n}\n\n.measurment_text {\n  font-family: AppFont, sans-serif;\n  font-size: 10px;\n  color: #9f9f9f;\n  text-align: left;\n  padding-top: 6px;\n}\n\n.add-button {\n  width: 100%;\n  padding: 0 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  min-height: 28px;\n  max-height: 28px;\n  min-width: 130px;\n  font-size: 12px;\n}\n\n.quantity-selector {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    margin: 0px 6px;\n    cursor: pointer;\n  }\n\n  z-index: 999;\n\n  .quantity {\n    font-size: 16px;\n    color: #1A1A18;\n  }\n\n  .quantity-btn {\n    width: 22px;\n    height: 22px;\n\n    &.add-opacity {\n      opacity: 0.5;\n    }\n  }\n}\n\n.selected_item_icon {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n\n  &.active {\n    z-index: 99;\n    opacity: 1;\n  }\n}\n\n.footer-section {\n  padding: 5px 0px 10px;\n}\n\n.separator {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 30px;\n\n  .line {\n    height: 8px;\n    background-image: url(../../../assets/losteria/dot-white.svg);\n    background-size: 7px 100%;\n  }\n  &--wide .line {\n    background-size: 8px 100%;\n  }\n\n}\n.info {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  color: #999999;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
